// extracted by mini-css-extract-plugin
export default {"content":"styles_content__XxT8C","itemButton":"styles_itemButton__22-u6","label":"styles_label__lT6-s"};